import type React from 'react';

import { Flex } from '@change-corgi/design-system-legacy/layout';
import { Text } from '@change-corgi/design-system-legacy/typography';
import type { QrCodeType } from '@change-corgi/middle-end-gql-schema';

import { PetitionQRCode } from './components/PetitionQRCode';
import { PetitionQRCodeDownloadLink } from './components/PetitionQRCodeDownloadLink';

export const PetitionQRCodeDownload: React.FC<{
	slugOrId: string;
	displaySize: number;
	displayType: QrCodeType;
	downloadType: QrCodeType;
	downloadSize?: number;
	descriptionText: string;
	downloadLinkText: string;
	downloadFilename?: string;
	onClick?: () => Promise<void>;
}> = ({
	slugOrId,
	displaySize,
	displayType,
	downloadSize,
	downloadType,
	descriptionText,
	downloadLinkText,
	downloadFilename,
	onClick,
}) => {
	return (
		<Flex sx={{ gap: '16' }}>
			<div sx={{ flexShrink: 0 }}>
				<PetitionQRCode slugOrId={slugOrId} size={displaySize} type={displayType} />
			</div>
			<Flex sx={{ flexDirection: 'column', gap: 8 }}>
				<Text>{descriptionText}</Text>
				<PetitionQRCodeDownloadLink
					slugOrId={slugOrId}
					size={downloadSize}
					type={downloadType}
					onClick={onClick}
					filename={downloadFilename}
				>
					{downloadLinkText}
				</PetitionQRCodeDownloadLink>
			</Flex>
		</Flex>
	);
};
